/* eslint-disable */
import $ from 'jquery';
import 'url-search-params-polyfill';
import MortgageUtils from './utils';
import Mediator from '../../common/scripts/observer';
import RangeSlider from '../range-slider';
import {Utils} from '../../common/scripts/utils';

const mediator = new Mediator();
const U = new MortgageUtils();

/**
 * 🟠🟠🟠🔸ORANGE FLAG!🔸🟧🟧🟧
 * Функциональность была изменена специально под этот проект
 */
class Mortgage {
    /**
     * Метод инициализирует модуль
     * @param {Object} wrap - обертка модуля
     */
    init(wrap) {
        this._getElements(wrap);
        this._subscribes();
        this._initCalcSliders();
    }

    /**
     * Метод получает требуемые элементы
     * @param {Object} wrap - обертка модуля
     */
    _getElements(wrap) {
        this.$wrap = $(wrap);
        this.$sliders = this.$wrap.find('.j-range-slider');
        this.$allCards = this.$wrap.find('.j-mortgage-card');
        this.$mortgageSubsidyTypes = this.$wrap.find('.j-mortgage-subsidy-type');
        this.$firstPayInput = this.$wrap.find('.j-range-slider.first-pay')
        this.$creditPercent = this.$wrap.find('.j-mortgage-slider__percent');
        this.$emptyResult = this.$wrap.find('.j-mortgage-empty');
        this.activeClass = 'is-active';
        this.disabledClass = 'is-disabled';
        this.minPV = 20.1;
        this.maxPV = 90;
    }

    /**
     * Инициализация слайдеров ипотечного калькулятора
     * @private
     */
    _initCalcSliders() {
        const rangeSliderSelectors = Array.from(this.$sliders);

        if (rangeSliderSelectors.length) {
            rangeSliderSelectors.forEach((rangeSliderSelector, i) => {
                Mortgage.initSlider(rangeSliderSelector, i);
            });
        }
    }

    static initSlider(slider) {
        const rangeSlider = new RangeSlider();

        rangeSlider.init({wrapper: slider});
    };

    /**
     * Метод содержит в себе колбэки на событиях других модулей
     * @private
     */
    _subscribes() {
        mediator.subscribe('rangeSliderStart', (data, rangeSlider) => {
            data.$input = data.input.closest('.j-range-slider').find('.range-slider__input');
            data.$postfix = data.input.closest('.j-range-slider').find('.range-slider__input-label_right_side');
            data.$rangeSlider = rangeSlider;
            this.updateSlidersValues(data, null);
            this.manualInput(data, this);
            this.setCredit();
            this.update();
        });

        mediator.subscribe('rangeSliderChange', (data) => {
            this.updateSlidersValues(data, 'set');
            // TODO Если мы изменяем слайдер (цену, срок ипотеки), который не относятся к слайдеру первоначального взноса
            if (data.$input[0] !== this.$firstPayInput.find('.range-slider__input')[0]) {
                this.setFirstPay();
            }
            this.setCredit();
            this.update();
        });

        mediator.subscribe('rangeSliderFinish', () => {
            this.setCredit();
            this.setShareParam();
        });

        mediator.subscribe('tabChange', (data)=>{
            const minPv = parseFloat($(data).attr('data-min-pv')) ? parseFloat($(data).attr('data-min-pv')) : 0; // добавлено услвие, потому что может быть 0% первоначальный взнос
            const maxPv = parseFloat($(data).attr('data-max-pv'));
            if (!isNaN(maxPv)) this.minPV = minPv
            if (maxPv) this.maxPV = maxPv
            if (minPv || maxPv) {
                this.setFirstPay(true);
                this.setCredit();
                this.update()
            }
        })
    }

    /**
     * Обновление значений экземпляра слайдера и запись в хранилище сессии при необходимости
     * @param {Object} data - данные слайдеров
     * @param {String/Null} flag - флаг, показывающий, нужно ли записывать данные слайдеров в хранилище сессии
     */
    updateSlidersValues(data, flag = null) {
        this.updateData(data, flag); //todo проверить зис
        Mortgage.setInput(data.from, data);
        // this.setCredit();
    }

    /**
     * Считываем из хранилища или записываем в хранилище данные о текущем положении ползунков
     * @param {Object} data - все значения слайдера
     * @param {String} flag - флаг, указывающий, что данные нужно записать в хранилище
     */
    updateData(data, flag) {
        const key = U.getObjectData(data).key;
        const isDisabled = data.input[0].disabled;

        if (parseInt(Utils.getUrlParams(key)) && flag !== 'set' && !isDisabled) {
            data.from = parseInt(Utils.getUrlParams(key));
            U.accessStorage(key, data.from);
        } else if (U.isExist(U.accessStorage(key, null)) && flag !== 'set' && !isDisabled) {
            data.from = U.accessStorage(key, null);
        } else {
            data.from = parseInt(data.from);
            U.accessStorage(key, data.from);
        }
    }

    /**
     * Записываем в инпуты значения слайдеров.
     * Добавляем разрядные пробелы и постфикс для срока кредита
     * @param {Object} value - значение слайдера
     * @param {Object} data - параметры слайдера
     */
    static setInput(value, data) {
        data.$input[0].value = value.toLocaleString('ru-Ru');
    }

    /**
     * Выводим сумму и процент кредита
     * Если процент больше 100, выделяем его красным, а сумму кредита не выводим
     */
    setCredit() {
        this.$creditPercent.text(U.calcCredit().percent);
    }

    /**
     * Метод для непосредственного взаимодействия с инпутами (без использования слайдеров)
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     */
    manualInput(data, obj) {
        this.chooseInputInteraction(data, obj, 'focus');
        this.chooseInputInteraction(data, obj, 'blur');
        this.chooseInputInteraction(data, obj, 'keyup');
        this.chooseInputInteraction(data, obj, 'keydown');
    }

    /**
     * Определение поведения инпутов и слайдеров при взаимодействии с инпутами
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     * @param {String} interaction - тип взаимодействия с инпутом
     */
    chooseInputInteraction(data, obj, interaction) {
        let onlyNumbersRegexp = /[^0-9.]/g;
        const that = this;

        data.$input.on(interaction, function(e) {
            switch (interaction) {
                case 'focus':
                    U.use$Value(this, '');
                    break;
                case 'blur':
                    if (U.use$Value(this) === '') {
                        Mortgage.setInput(data.from, data);
                    } else {
                        U.checkInputedData(this, data, onlyNumbersRegexp);
                        that.updateSlidersValues(data, 'set');
                        data.$rangeSlider.slider.update();
                        that.update();
                    }
                    break;
                case 'keyup':
                    if (U.use$Value(this)) {
                        Mortgage.setInput(+(U.use$Value(this).replace(onlyNumbersRegexp, '')), data);
                    }
                    break;
                case 'keydown':
                    U.preventNaNSymbolsEnter(e);
                    U.onKeyDownEvent(e, data, obj, this, onlyNumbersRegexp);
                    break;
                default: console.error('Wrong type of interaction');
            }
        });
    }

    /**
     * Рассчитываем ежемесячный платёж по формуле:
     * @param {Number} rate - ставка
     * @param {Number} additionalCost - наценка банка
     * @return {Number} - ежемесячный платёж
     * A = K * S,
     * где A - ежемесячный аннуитетный платёж,
     * K - коэффициент аннуитета,
     * S - сумма кредита.
     * K = (i * (1 + n)^n) / (((1 + i)^n) - 1)
     * i - месячная процентная ставка по кредиту (годовая/12)
     * n - количество периодов, в течение которых выплачивается кредит
     */
    static calcMonthlyPay(rate, additionalCost) {

        const i = rate / 12 / 100;
        const n = U.accessStorage('limitation[min]') * 12;
        const kNumerator = i * Math.pow(1 + i, n);
        const kDenominator = Math.pow(1 + i, n) - 1;
        const _K = kNumerator / kDenominator;
        const _S = U.accessStorage('creditAmount') + additionalCost;
        const _A = _K * _S;

        return _A < 0 ? '—' : _A;
    }

     /**
     * Высчитываем и устанавливаем ежемесячный платёж каждому банку
     */
    setPaymentOnTable() {
         [this.$allCards].forEach((item) => {
             for (let i = 0; i < item.length; i++) {
                 const additionalCost = Mortgage.setAdditionalCost($(item[i]));
                 Mortgage.calcPaymentForBank($(item[i]), additionalCost);
                 Mortgage.setFirstPayResult($(item[i]));
                 Mortgage.setLimitation($(item[i]));

                 const $flatPriceNode = $(item).find('.j-mortgage-flat-price');
                 const price = U.accessStorage('price[min]');

                 if ($flatPriceNode && price) {
                     $flatPriceNode.text(price.toLocaleString('ru-Ru') + ' ₽');
                 }
             }
         });
    }

    static calcPaymentForBank(item, additionalCost) {
        let rate = +item.find('.j-mortgage-rate').attr('data-rate');

        let monthlyPayment = U.isExist(Mortgage.calcMonthlyPay(rate, additionalCost)) ?
            U.calc('monthlyPaymentPretty', Mortgage.calcMonthlyPay(rate, additionalCost), null) : '—';
        item.find('.j-mortgage-payment').text(monthlyPayment);
    }

    static setFirstPayResult(item) {
        let pay = +item.find('.j-mortgage-first-payment').attr('data-firstPayment');
        let price = U.accessStorage('price[min]', null);

        let firstPayment = U.calc('monthlyPaymentPretty', (price * pay / 100));
        item.find('.j-mortgage-first-payment-val').text(firstPayment);
    }

    static setAdditionalCost(item) {
        const valueNode = item.find('.j-mortgage-addition-cost');
        let additionalCostValue = valueNode.attr('data-additional-cost');
        let price = U.accessStorage('price[min]', null);
        let additionalCost;
        let additionalCostPretty;

        if (isNaN(+additionalCostValue)) {
            additionalCostPretty = additionalCostValue || 'нет удорожания';
        } else {
            additionalCost = (price * additionalCostValue) / 100
            // const fixedAdditionalCost = parseInt(additionalCost.toFixed());
            // additionalCostPretty = `+ ${fixedAdditionalCost.toLocaleString('ru-Ru')} ₽`;

            additionalCostPretty = additionalCostValue + '%';
        }

        valueNode.text(additionalCostPretty);

        return additionalCost || 0;
    }

    static setLimitation(item) {
        const valueNode = item.find('.j-mortgage-limitation[data-update-limitation]');
        const currentLimitation = U.accessStorage('limitation[min]', null);

        valueNode.text(currentLimitation);
    }

    /**
     * Передаём список банков на проверку соответствия условиям
     * @private
     */
    _disableItems() {
        [this.$allCards].forEach((item) =>  {
            for (let i = 0; i < item.length; i++) {
                this._setDisabled($(item[i]));
            }
        });
    }

    /**
     * Отключаем банк, если он не подходит по параметрам
     * @param {Object} item - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setDisabled(item) {
        let firstPaymentCell  = item.find('.j-mortgage-first-payment');
        let limitationCell    = item.find('.j-mortgage-limitation');
        let monthlyPayment    = item.find('.j-mortgage-payment');
        let firstPayment      = +firstPaymentCell.attr('data-firstPayment');
        let firstPaymentMax   = +firstPaymentCell.attr('data-firstPaymentMax');
        let limitation        = +limitationCell.attr('data-limitation');
        let limitationMin     = +limitationCell.attr('data-limitationMin');
        let creditSummMax     = +item.attr('data-creditAmountMax');
        let creditSummMin     = +item.attr('data-creditAmountMin');

        if (U.accessStorage('creditPercent') < firstPayment    ||
            U.accessStorage('creditPercent') > firstPaymentMax ||
            U.accessStorage('limitation[min]') > limitation    ||
            U.accessStorage('limitation[min]') < limitationMin ||
            U.accessStorage('creditAmount')  < creditSummMin   ||
            U.accessStorage('creditAmount')  > creditSummMax) {
            monthlyPayment.text('—');
            item.addClass(this.disabledClass);
        } else {
            item.removeClass(this.disabledClass);
        }
    }

    /**
     * Скрывает группу без результатов
     * @private
     */
    _disableSubsidyGroup(group) {
        const isGroupNotEmpty = $(group).children().not(`.${this.disabledClass}`).length;

        if (isGroupNotEmpty) {
            $(group).removeClass(this.disabledClass);
        } else {
            $(group).addClass(this.disabledClass);
        }
    }

    /**
     * Скрывает группу без результатов
     * @private
     */
    _findCheapestInSubsidyGroup(group) {
        let specialOrderCoefficient = 10000000;
        let cheapestBank = null;

        $(group).children().each((index, child) => {
            $(child).removeClass(this.activeClass);

            if ($(child).hasClass(this.disabledClass)) {
                return;
            }

            const order = +$(child).css('order');

            if (order < specialOrderCoefficient) {
                cheapestBank = child;
                specialOrderCoefficient = order;
            }
        })

        $(cheapestBank).addClass(this.activeClass);
    }

    _showedMultipleInSubsidyGroup(group) {
        // Фильтруем элементы по условию parentNode
        const filteredItems = Array.from(group).filter(item =>
            item.parentNode.classList.contains('j-mortgage-subsidy-type') &&
            !item.parentNode.classList.contains('mortgage__subsidy-type_theme_green') &&
            !item.parentNode.classList.contains('mortgage__subsidy-type_theme_white')
        );

        // Сортируем по dataset.payment (по возрастанию)
        filteredItems.sort((a, b) => {
            const paymentA = parseFloat(a.dataset.payment) || 0;
            const paymentB = parseFloat(b.dataset.payment) || 0;
            return paymentA - paymentB;
        });

        // Берем первые 3 элемента (с наименьшим payment)
        const topThreeItems = filteredItems.slice(0, 4);

        // Добавляем класс is-active
        topThreeItems.forEach(item => {
            console.log(item.dataset.payment)
            if (item.dataset.payment !== "10000000") {
                item.classList.add('is-active');
            }
        });
    }

    /**
     * Выводит плашку об отсутствии результатов
     * NB! Очень специфичный код, не подходит для переноса на другие проекты
     * @private
     */
    _checkEmptyResult() {
        this.$emptyResult.each((id, item) => {
            const $emptyResult = $(item);
            const $resultsWrapper = $emptyResult.parent();

            const isEveryCardsDisabled = !$resultsWrapper.find('.j-mortgage-card').not(`.${this.disabledClass}`).length
            const method = isEveryCardsDisabled ? 'addClass' : 'removeClass';

            $emptyResult[method](this.activeClass);
        })
    }

    /**
     * Передаём строки таблицы с банками на упорядочивание
     */
    _setTableOrder() {
        for (let i = 0; i < this.$allCards.length; i++) {
            this._setItemOrder($(this.$allCards[i]));
        }
    }

    /**
     * Устанавливаем свойство order для каждого банка, чтобы упорядочить элементы по цене
     * @param {Object} obj - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setItemOrder(obj) {
        const specialOrderCoefficient = 10000000;
        let payment = +obj.find('.j-mortgage-payment').text().replace(/[^0-9]/g, '');
        obj.attr('data-payment', (payment === 0) ? specialOrderCoefficient : payment);

        if (obj.attr('data-sort') && !obj.hasClass(this.disabledClass)) {
            payment = +obj.data('sort');
        }

        obj.css('order', (payment === 0) ? specialOrderCoefficient : payment);
    }

     /**
     * Алгоритм MergeSort. Почти во всех браузерах используется по умолчанию,
     * однако google chrome использует данный алгоритм исключительно когда элементов для сортировки меньше 10
     * если элементов больше, что chrome начинает использовать QuickSort.
     * QuickSort значительно быстрее, нежели MergeSort, однако, в отличие от MergeSort, является нестабильным
     * (Unstable Algorithm, сортировка происходит без сохранения индексации элементов).
     * Из-за отсутствия индексации элементы с одинаковыми значениями хаотично меняются местами при сортировке.
     * WARNING! Не отключайте MergeSort для гугла, пожалейте эпилептиков
     * @param {Array} rows - массив строк таблицы банков
     * @return {Array} - смерженный массив
     */
    mergeSort(rows) {
        if (rows.length <= 1) {
            return rows;
        }

        const middle = Math.floor(rows.length / 2);
        const left = rows.slice(0, middle);
        const right = rows.slice(middle, rows.length);

        return Mortgage.merge(this.mergeSort(left), this.mergeSort(right));
    }

    /**
     * Вспомогательная функция для алгоритма MergeSort
     * @param {Array} left - массив для слияния
     * @param {Array} right - массив для слияния
     * @return {Array} - отсортированный массив
     */
    static merge(left, right) {
        let result = [];

        while (left.length && right.length) {
            if (Mortgage.mergeSortFunction(left[0], right[0]) < 1) {
                result.push(left.shift());
            } else {
                result.push(right.shift());
            }
        }

        while (left.length) {
            result.push(left.shift());
        }

        while (right.length) {
            result.push(right.shift());
        }

        return result;
    }

    /**
     * Вспомогательная функция для алгоритма MergeSort.
     * @param {Object} a - объект сортировки
     * @param {Object} b - объект сортировки
     * @return {Number} - число, знак которого определяет местоположение элемента при сортировке
     */
    static mergeSortFunction(a, b) {
        return +$(a).css('order') - (+$(b).css('order'));
    }

    /**
     * Функция обновления значений ипотечной таблицы, карточек и количества предложений
     */
    update() {
        this.setPaymentOnTable();
        this._disableItems();
        this._checkEmptyResult();
        this._setTableOrder();

        [...this.$mortgageSubsidyTypes].forEach((group) => {
            this._disableSubsidyGroup(group);
            this._findCheapestInSubsidyGroup(group);
        })

        this._showedMultipleInSubsidyGroup([...this.$allCards]);
    }

    setShareParam() {
        const query = new URLSearchParams();

        query.append('calcPriceMean', U.accessStorage('price[min]'));
        query.append('calcFirstPaymentPercent', U.accessStorage('first-pay[min]'));
        query.append('calcPeriodMean', U.accessStorage('limitation[min]'));

        window.history.pushState(null, null, `?${query.toString()}`);
    }

    /*
    * TODO Необходимо переделать
    * При изменении значения в слайдере, мы расчитываем ПВ
    * Обновляем ionRangeSlider и заменяем значение в .value
    */
    setFirstPay(setMinPv = false) {
        const price  = U.accessStorage('price[min]', null);
        let firstPay = U.accessStorage('first-pay[min]', null);

        if (price && firstPay) {
            const minFirstPay = parseInt(price / 100 * this.minPV);
            const maxFirstPay = parseInt(price / 100 * this.maxPV);

            if (firstPay < minFirstPay) U.accessStorage('first-pay[min]', minFirstPay);
            if (firstPay > maxFirstPay) U.accessStorage('first-pay[min]', maxFirstPay);
            if (setMinPv) U.accessStorage('first-pay[min]', minFirstPay);
            firstPay = U.accessStorage('first-pay[min]');

            if (this.$firstPayInput) {
                this.$firstPayInput
                    .find('.j-range-slider__base')
                    .data('ionRangeSlider')
                    .update({
                        max: maxFirstPay,
                        min: minFirstPay,
                        from: firstPay,
                    });

                this.$firstPayInput.find('.range-slider__input')[0].value = firstPay.toLocaleString('ru-Ru');
            }
        }
    }
}

export default Mortgage;
/* eslint-enable */
